import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import common from '../../../common/common';
import JSCheckout from '../jscheckout';
import Redirection from '../redirection';
import { onChange } from '../../../controller/theme_checkout';
import { locale } from '../../../utils/i18n';

class Preview extends Component {
  constructor(props) {
    super(props);
  }

  onPreviewTabChange = (label, value) => {
    if (this.props && this.props.onPreviewTabChange) {
      common.log('onPreviewTabChange', label);
      this.props.onPreviewTabChange(value);
    }
  };

  render({ isRedirectionTabSelected, isThematicFeatureUsed }) {
    return (
      <div class="right-content left">
        <p class="preview-info uppercase metalic-blue">{locale('checkout.preview')}</p>
        <div class="tab-area">
          <ul class="tab-list">
            <li
              className={`${!isRedirectionTabSelected ? 'active-mode' : ''} `}
              onClick={this.onPreviewTabChange.bind(this, locale('checkout.title'), false)}
            >
              {locale('checkout.checkout.tab')}
            </li>
            {/* {isThematicFeatureUsed && (
              <li
                className={`${isRedirectionTabSelected ? 'active-mode' : ''} `}
                onClick={this.onPreviewTabChange.bind(this, 'Redirection', true)}
              >
                {locale('checkout.redirection.tab')}
              </li>
            )} */}
          </ul>
          {!isRedirectionTabSelected && <JSCheckout />}
          {/* {isThematicFeatureUsed && isRedirectionTabSelected && <Redirection />} */}
        </div>
      </div>
    );
  }
}

export default connect(
  'isRedirectionTabSelected, isThematicFeatureUsed',
  onChange
)(Preview);



// WEBPACK FOOTER //
// ./checkout/components/preview/index.js